/** Small bordered disclosure used for secondary Kuali settings. */
import type { ReactNode } from 'react'
import { ChevronDown } from 'lucide-react'

import { cn } from '@/lib/utils'

export function KualiResearchDisclosure({
  title,
  summary,
  open,
  onOpenChange,
  children,
}: {
  title: string
  summary: ReactNode
  open: boolean
  onOpenChange: (open: boolean) => void
  children: ReactNode
}) {
  return (
    <section className="overflow-hidden rounded-[10px] border border-slate-200 bg-white">
      <button
        type="button"
        className="flex min-h-[48px] w-full items-center justify-between gap-3 px-3.5 py-2.5 text-left"
        aria-expanded={open}
        onClick={() => onOpenChange(!open)}
      >
        <span className="min-w-0">
          <span className="block text-[12.5px] font-semibold text-slate-900">{title}</span>
          {!open && <span className="mt-px block truncate text-[11.5px] text-slate-500">{summary}</span>}
        </span>
        <ChevronDown className={cn('h-3.5 w-3.5 shrink-0 text-slate-400 transition-transform', open && 'rotate-180')} />
      </button>
      {open && children}
    </section>
  )
}
